import mem from 'mem';
import axios from 'axios';
import { store } from '../index';
import { userUpdated } from '../redux/auth/actions';
import { getLoggedInUser } from './authUtils';

const getNewToken = async () => {
    const user = getLoggedInUser();
    const token = user ? user.token : null;
    if (token) {
        const res = await axios.post(`${process.env.REACT_APP_API_URL}api/refresh`, { token })
                                .catch(() => {
                                    store.dispatch(userUpdated(null));
                                    window.location.href = '/account/login';
                                });

        if (res) {
            user.token = res.data.token;
            store.dispatch(userUpdated(user));
        }
    }
};

export const memoizedGetNewToken = mem(getNewToken, { maxAge: 30000 });
